var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-settings"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M15.694 12.459a3.234 3.234 0 11-3.235-3.234 3.234 3.234 0 013.235 3.234z",
    "data-name": "Path 1379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.437 15.694a1.779 1.779 0 00.356 1.962l.065.065a2.15738279 2.15738279 0 11-3.051 3.051l-.065-.065a1.793 1.793 0 00-3.04 1.272v.183a2.1565 2.1565 0 01-4.313 0v-.1a1.779 1.779 0 00-1.164-1.628 1.779 1.779 0 00-1.962.356l-.065.065a2.15738279 2.15738279 0 11-3.051-3.051l.065-.065A1.793 1.793 0 002.94 14.7h-.184a2.1565 2.1565 0 010-4.313h.1a1.779 1.779 0 001.628-1.164 1.779 1.779 0 00-.356-1.962L4.061 7.2a2.15809001 2.15809001 0 113.051-3.053l.065.065a1.779 1.779 0 001.962.356h.086A1.779 1.779 0 0010.3 2.94v-.184a2.1565 2.1565 0 114.313 0v.1a1.793 1.793 0 003.04 1.272l.065-.065a2.15738279 2.15738279 0 113.051 3.051l-.065.065a1.779 1.779 0 00-.356 1.962v.086a1.779 1.779 0 001.631 1.073h.183a2.1565 2.1565 0 010 4.313h-.1a1.779 1.779 0 00-1.628 1.078z",
    "data-name": "Path 1380"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b5105598.svg";
export { ForwardRef as ReactComponent };